import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueApexCharts from 'vue-apexcharts'
import VueResource from 'vue-resource'
import Vuetify from 'vuetify'
import Moment from 'vue-moment';
import Loading from 'vue-loading-overlay';
import VueTheMask from 'vue-the-mask'
import VueMask from 'v-mask'
import vSelect from 'vue-select'
import vSelect2 from 'vue-select2'
import BootstrapVue from 'bootstrap-vue'
import DatePicker from 'vuejs-datepicker'
import VueEditor from 'vue2-editor'
import HighchartsVue from 'highcharts-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMaterial from 'vue-material'
import VueSlider from 'vue-slider-component'


import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vue-loading-overlay/dist/vue-loading.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-slot-calendar/lib/calendar.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';
import 'vue-material/dist/vue-material.min.css'
import 'vue-slider-component/theme/default.css'

Vue.use(VueApexCharts)
Vue.use(HighchartsVue)
Vue.use(VueResource)
Vue.use(Vuetify)
Vue.use(Moment)
Vue.use(VueTheMask)
Vue.use(VueMask)
Vue.use(BootstrapVue)
Vue.use(DatePicker)
Vue.use(VueEditor)
Vue.use(VueSweetalert2);
Vue.use(VueMaterial)
Vue.component('v-select', vSelect)
Vue.component('v-select2', vSelect2)
Vue.component('vue-slider', VueSlider)
Vue.component('loading', Loading)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
